import { alpha } from '@wojtekmaj/color-utils';

import colors from './colors';

const colorsTaiwan = {
  ...colors,
  background: '#fff',
  'background-1': '#2b2d40',
  'background-2': '#1d1d24',
  'card-background': '#fff',
  'dialog-background': '#fff',
  'menu-background': '#fff',
  text: '#231f20',
  'text-light': alpha('#231f20', 0.75),
  'text-muted': alpha('#231f20', 0.25),
} as const;

export default colorsTaiwan;
